import styled from 'styled-components';
import { Grid } from '../../../ui-toolkit';

export const GridWithBorderBottom = styled(Grid)`
  align-items: stretch;
  gap: 0;
  > * {
    border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
    padding: ${(props) => props.theme.spacing.spacing5};
  }
`;
